'use strict';

import warningDialogTemplate from './warningDialog.directive.html';

export default angular
  .module('maestro.directives.components.warning-dialog', [])
  .directive('warningDialog', () => {
      return {
        restrict: 'E',
        template: warningDialogTemplate,
        replace: true,
        scope: {
          wdId: '@wdId',
          wdTitle: '@wdTitle',
          wdDesc: '@wdDesc',
          wdBtnYes: '@wdBtnYes',
          wdBtnNo: '@wdBtnNo',
          wdShowBtnYes: '=wdShowBtnYes',
          wdShowBtnNo: '=wdShowBtnNo',
          wdBtnIcon: '@wdBtnIcon',
          wdPositive: '=wdPositive',
        },
        link: (scope, element) => {
          element.on('$destroy', () => {

            // TODO: remove the warning dialog if it's detachable
            // to do not duplicate existing dialogs every time controller loaded
            // console.log(element);

          });
        },
        controller: ($scope, $sce, $filter) => {
          const $t = $filter('translate');

          $scope.$watch('wdTitle', () => {
            $scope.wdTitleTrustedHtml = $scope.wdTitle ? $sce.trustAsHtml($t($scope.wdTitle)) : void 0;
          });

          $scope.$watch('wdDesc', () => {
            $scope.wdDescTrustedHtml = $scope.wdDesc ? $sce.trustAsHtml($t($scope.wdDesc)) : void 0;
          });
        }
      };
    }
  )

  .name;
